export default __webpack_public_path__ + "static/media/widowmaker-widowskiss.ac17dc8a.mp3";